import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiCall } from '@shared/async-services/http/api-call.service';
import { CommonService } from '@shared/services/common.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  public changePwd: FormGroup;
  hide: boolean = false;
  hide1: boolean = false;
  hide3: boolean = false;
  public changePasswordEvent: EventEmitter<boolean>;
  token: any;

  public submitted = false;

  constructor(
    private fb: FormBuilder,
    private auth: ApiCall,
    private router: Router,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    private commonService: CommonService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.changePasswordEvent = this.commonService.changePasswordEvent;
    this.changePwd = this.fb.group({
      newPassword: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")]],
      oldpassword: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")]],
      confirmpassword: ["", [Validators.required,Validators.minLength(8),Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")]],
    },
    {
      validator: ConfirmedValidator('newPassword', 'confirmpassword')
    });
  }

  get formControl() {
    return this.changePwd.controls;
  }


  save() {
    this.submitted = true;
    if (!this.changePwd.valid) {
      return;
    }
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.auth.changedPassword(this.changePwd.value.oldpassword,this.changePwd.value.newPassword, currentUser.email).subscribe(
      (res: any) => {
        if (res.status == "SUCCESS") {
          let message;
          if(res.message == 'Password reset successfully.') {
            this.translate.get(['SUPER_ADMIN.USERS.PASSWORD_UPDATE'])
            .subscribe(translations => {
              message = translations['SUPER_ADMIN.USERS.PASSWORD_UPDATE'];
          });   
          this.toastr.success(message, '', {
            timeOut: 3000
          });
         }
    
          this.dialogRef.close(false);
        } else if (res.status == "FAIL") {
          this.toastr.error(res.message, '', {
            timeOut: 3000
          });
        }
      },
      (err: any) => {
        console.log("Something went wrong");
      }
    );
  }

  cancel(){
      // Close the dialog, return false
      this.dialogRef.close(false);
      this.changePasswordEvent.emit(false);
  }

}
  
  
function ConfirmedValidator(controlName: string, matchingControlName: string): any {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
        return;
    }
    if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
    } else {
        matchingControl.setErrors(null);
    }
}
}
